var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVolumeMuteNew = function SvgVolumeMuteNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.465 13.912c0 .62-.47 1.088-1.11 1.088-.444 0-.802-.176-1.229-.578l-3.568-3.298a.288.288 0 0 0-.196-.075H1.946C.683 11.05 0 10.363 0 9.065V5.951c0-1.297.683-1.983 1.946-1.983h2.416a.273.273 0 0 0 .196-.076L8.126.62C8.587.176 8.903 0 9.338 0c.657 0 1.127.502 1.127 1.13v12.782zm7.306-8.684a.78.78 0 0 1 0 1.105L16.154 7.95l1.617 1.617a.781.781 0 0 1-1.104 1.104L15.05 9.054l-1.617 1.617a.78.78 0 0 1-1.104-1.104l1.617-1.617-1.617-1.617a.78.78 0 0 1 1.104-1.105l1.617 1.617 1.617-1.617a.78.78 0 0 1 1.104 0z",
    fill: "#8B8C8E"
  })));
};
export default SvgVolumeMuteNew;